export default {
  "meta-title": "TARISLAND",
  "meta-description": "Tarisland é um MMORPG para PC e dispositivos móveis. Nele, há invasões, classes variadas, jogabilidade cruzada e um vasto mundo para explorar. Embarquem juntos nessa aventura",
  "meta-keywords": "tarisland,taris,comme wow,mmo,mmorpg,multiplateforme,mmomobile,mmoPC",
  "meta-name": "Site Oficial de Tarisland",
  "meta-image": "${HOST_NAME}/assets/images/share.jpg",
  "meta-og-site_name": "Site Oficial de Tarisland",
  "meta-og-title": "Site Oficial de Tarisland",
  "meta-og-description": "Curta um MMORPG clássico multiplataforma e forme uma equipe com seus amigos próximos para completar as invasões mais desafiadores.",
  "meta-og-url": "${HOST_NAME}/${LANG}/home.html",
  "meta-og-url2": "${HOST_NAME}/${LANG}/index.html",
  "meta-og-image": "${HOST_NAME}/assets/images/share.jpg",
  "meta-twitter-site": "${HOST_NAME}",
  "meta-twitter-title": "Site Oficial de Tarisland",
  "meta-twitter-description": "Curta um MMORPG clássico multiplataforma e forme uma equipe com seus amigos próximos para completar as invasões mais desafiadores.",
  "meta-twitter-url": "${HOST_NAME}/${LANG}/home.html",
  "meta-twitter-url2": "${HOST_NAME}/${LANG}/index.html",
  "meta-twitter-image": "${HOST_NAME}/assets/images/share.jpg",



  "email_illegal": "Endereço de email incorreto. Por favor, verifique e envie novamente.",
  "horizon_tip": "Para uma melhor experiência, por favor gire seu dispositivo.",

  'downloadPc': "Please download on PC",

  "area": "Área",
  "select-area": "Selecione a área",
  "server": "Servidor",
  "select-server": "Selecione o servidor",
  "character-name": "Nome do personagem",
  "select-character": "Selecione o personagem",
  "please-select": "Selecione",
  "not-found-role": "Informação de personagem não encontrada",
  'loading': '加載中....',
  'pls_input_info': '請輸入您的登錄信息。',
  'FlowHasNotBegin': 'The event has not started yet',
  'FlowHasEnd': 'The event has ended',

  // 复制到剪贴板内容 需要拼接
  "copy_clipboard-text1": "Torne-se meu parceiro em Tarisland!\nClique/toque em:",
  "copy_clipboard-text2": "(link exclusivo)\nCaso o link não funcione, use o seguinte código de convite:",
  "friends-completed": "amigos completaram",
  "no-friends-completed": "0 amigos completaram",
  "pop_invitedlist_s": "COMPLET.",
  "pop_invitedlist_f": "INCOMP.",
  "gift3": "Pacote de Crescimento da T1",
  "gift5": "Espírito do Lobo de Gelo (Permanente)",
  "gift6": "Espírito do Lobo de Gelo(1 Dia)",
  "gift1": "Cartão-presente de $100",
  "gift2": "Cartão-presente de $50",
  "gift4": "Espírito do Tigre de Fogo (Permanente)",

  "invite_link_upper_limit": "O link ou código de convite já atingiu o número máximo de usos.",
  "invite_link_disabled": "Link de convite inválido ou código expirado. Confirme-o com quem convidou você.",
  "enter_your_invitation_code": "Digite seu código de convite",
  "act_not_start": "O evento não começou.",
  "act_finished": "O evento terminou.",
  "download_pc": "Faça o download no PC",
  "email_error": "E-mail inválido. Confirme-o.",
  "loadding": "Carregando...",
  "check_my_raffle_history": "Visualizar histórico de sorteio",
  "no_raffle_history": "Sem histórico de sorteio",
  "system-error": "Erro de sistema",
  "cant-invite-self": "Você não convidar a si mesmo",

}